import { render, staticRenderFns } from "./PasswordResetNewPasswordPage.vue?vue&type=template&id=04bbe7be"
import script from "./PasswordResetNewPasswordPage.vue?vue&type=script&lang=ts"
export * from "./PasswordResetNewPasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetNewPasswordPage.vue?vue&type=style&index=0&id=04bbe7be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports